import * as types from './actionTypes';
import sasApi from '../api/sasApi'

export function ConsultaSASSuccess(sas) {
    return { type: types.CONSULTA_SAS, sas }
}

export function ConsultaSAS(parametros) {
    return function (dispatch) {

        return sasApi.ConsultaSAS(parametros).then(sas => {
            dispatch(ConsultaSASSuccess(sas));
        }).catch(error => {
            throw (error);
        });

    };
}


/** WEBPACK FOOTER **
 ** ./src/components/actions/sasActions.js
 **/